import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import HeroSection from './HeroSection';
import * as Typography from './Typography';

import firebase from './firebase';

function DeliveryWindow(props) {
  return (
    <div style={{margin: "15px", display: 'inline-block'}}>
      <RaisedButton
        onClick={props.onSelected}
        label={props.window.value.display_title}
        />
    </div>
  )
}

const ScheduleDeliveryPage = muiThemeable()(class extends Component {
  state = {
    uid: null,
    user: null,
    delivery_windows: null,
  }

  componentDidMount() {
    firebase.database().ref().child("delivery").child("windows").on('value',
      (snapshot) => {
        var windows_by_date = {};
        for (var key in snapshot.val()) {
          if (snapshot.val().hasOwnProperty(key)) {
            var val = snapshot.val()[key];
            if (!(val.date in windows_by_date)) {
              windows_by_date[val.date] = {display_date: val.display_date, items: []};
            }
            windows_by_date[val.date].items.push({key: key, value: val});
          }
        }
      this.setState({delivery_windows: windows_by_date});
    });

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.userRef = firebase.database().ref().child('users').child(user.uid);
        this.listener = this.userRef.on('value',
          (snapshot) => {
            this.setState({uid: user.uid, user: snapshot.val()});

            if (snapshot.hasChild('delivery_window')) {
              var window_id = snapshot.child('delivery_window').val();
              firebase.database().ref().child("delivery").child("windows").child(window_id).on('value',
                (windowSnapshot) => {
                  this.setState({window: windowSnapshot.val()});
              });
            }
          }
        );
      } else {
        this.setState({user: null});
        document.location="/login?next=/schedule-delivery";
      }
    }, function(error) {
      console.log(error);
    });
  }

  selectWindow(window) {
    this.userRef.child('delivery_window').set(window.key);
    document.location="/confirm-delivery?window=" + window.key;
  }

  renderDeliveryWindows = () => {
    var jsx = [];
    var dates = [];
    for (var date_ in this.state.delivery_windows) {
      if (this.state.delivery_windows.hasOwnProperty(date_)) {
        dates.push(date_);
      }
    }

    dates.sort();
    console.log(dates);

    for (var i=0; i<dates.length; i++) {
      var date = dates[i];

      jsx.push(<h1 key={date}>{this.state.delivery_windows[date].display_date}</h1>);
      jsx = jsx.concat(this.state.delivery_windows[date].items.map((window) =>
         <DeliveryWindow
           key={window.key}
           window={window}
           onSelected={this.selectWindow.bind(this, window)} />
       ));
    }
    return jsx;
  }

  render() {
    return this.state.user && this.state.delivery_windows &&
       <div>
         <HomeGalleryHeader />

         <div style={{
             margin: 'auto',
             textAlign: 'center',
             fontWeight: 'normal',
             backgroundColor: this.props.muiTheme.palette.canvasColor,
             fontFamily: "'Roboto', sans-serif",
           }}>
           <HeroSection
             header="Select a time for delivery." />

           { this.state.window &&
             <div style={{
                 backgroundColor: this.props.muiTheme.palette.butterbarColor,
                 padding: '15px 5%',
               }}>
               <Typography.Body1>You currently have a delivery scheduled for {this.state.window.display_date} from {this.state.window.display_title}. Choosing a delivery here will replace it.</Typography.Body1>
             </div>
           }
           { this.renderDeliveryWindows() }

          </div>
         <HomeGalleryFooter />
       </div>
  }
});

export default ScheduleDeliveryPage;



// WEBPACK FOOTER //
// ./src/ScheduleDeliveryPage.js